<script lang="ts">
	import { locale } from 'svelte-i18n';
	import { page } from '$app/stores';

	export let redirectUri: string | undefined = undefined;
	export let classNames: string[] = [];

	const blacklist = ['/auth/', '/error/'];

	$: internalRedirectUri = redirectUri || $page.url.pathname;
	$: filteredRedirectUri = blacklist.includes(internalRedirectUri) ? '/' : internalRedirectUri;
	$: href = $page.data.session?.user
		? `/${$locale}/auth/logout?redirect_uri=${filteredRedirectUri}`
		: `/${$locale}/auth/login?redirect_uri=${filteredRedirectUri}`;
</script>

<a {href} role="button" data-testid="login-link" class={classNames.join(' ')}>
	<slot />
</a>
